import React, { useContext, useRef } from "react";
import styled from "styled-components";
import { Transition, TransitionGroup } from "react-transition-group";
import CoreContext from "~/lib/context";
import { enterSideBar, exitSideBar } from "~/lib/animations";
import NotificationDropdown from "~/components/NotificationDropdown";
import { useAbac } from "react-abac";
import { AuthoritiesEnum } from "~/types/enums";
import SearchDropdown from "~/components/SearchDropdown";
import ErrorBoundaryCard from "~/components/ErrorBoundaryCard";
const Wrapper = styled.aside`
  position: absolute;
  right: 50%;
  top: 0;
  height: 100%;
  min-height: 100vh;
  margin-right: -51.4rem;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.secondary;
}};
  z-index: 1;

  @media (max-width: 1440px) {
    right: 0;
    margin-right: 0;
  }
`;
const SidebarWrapper = styled.aside`
  overflow: hidden;
  height: 100%;

  & > * {
    height: 100%;
    min-height: 100vh;
  }
`;
const Navbar = styled.div`
  position: absolute;
  top: 3.8rem;
  right: 2.8rem;
  padding: 0.7rem;
  width: 22.8rem;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  gap: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.typography.fontStep * 3;
}}rem;
  border-radius: 5em;
  backdrop-filter: blur(3px);
  transition: box-shadow 400ms ease-out;
  align-items: center;
`;
const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${_ref3 => {
  let {
    navbarShown
  } = _ref3;
  return navbarShown ? "10.7rem" : "3.6rem";
}} 3.6rem 3.6rem;
  min-height: 100vh;
  height: 100%;
  width: 28.6rem;
  min-width: 28.6rem;
  max-width: 28.6rem;
  border-left: 1px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.borders.primary;
}};
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  transition: width 1300ms ease-in-out;

  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &:hover::-webkit-scrollbar-thumb {
    display: initial;
  }
`;
const RightSideBar = () => {
  const {
    sidebar
  } = useContext(CoreContext);
  const {
    userHasPermissions
  } = useAbac();
  const sidebarRef = useRef(null);
  /* @ts-ignore */
  const sidebarName = sidebar?.type?.name;
  return /*#__PURE__*/React.createElement(Wrapper, null, (userHasPermissions(AuthoritiesEnum.SEARCH_READ) || userHasPermissions(AuthoritiesEnum.NOTIFICATIONS_READ) || userHasPermissions(AuthoritiesEnum.COMMUNITIES_READ)) && /*#__PURE__*/React.createElement(Navbar, null, /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, userHasPermissions(AuthoritiesEnum.SEARCH_READ) && /*#__PURE__*/React.createElement(SearchDropdown, {
    fullWidth: true
  }), userHasPermissions(AuthoritiesEnum.NOTIFICATIONS_READ) && /*#__PURE__*/React.createElement(NotificationDropdown, null))), /*#__PURE__*/React.createElement(SidebarWrapper, null, /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null
  }, /*#__PURE__*/React.createElement(Transition, {
    key: sidebarName,
    onEnter: node => enterSideBar(node),
    onExit: node => exitSideBar(node),
    timeout: {
      enter: 750,
      exit: 400
    },
    appear: true
  }, /*#__PURE__*/React.createElement("div", null, sidebar && /*#__PURE__*/React.createElement(Sidebar, {
    ref: sidebarRef,
    navbarShown: userHasPermissions(AuthoritiesEnum.SEARCH_READ) || userHasPermissions(AuthoritiesEnum.NOTIFICATIONS_READ) || userHasPermissions(AuthoritiesEnum.COMMUNITIES_READ)
  }, /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, sidebar)))))));
};
export default RightSideBar;